import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { selectModelList } from '../../corporatePerformanceScore/store/slice'
import { getModelLists } from '../../corporatePerformanceScore/store/thunk'
import { ContactUs } from './components/ContactUs'
import { CreditScore } from './components/CreditScore'
import { PredictiveModel } from './components/PredictiveModel'
import { Title } from './components/Title'
import { Upgrade } from './components/Upgrade'

export const StandardComponent = () => {
  const dispatch = useDispatch()
  const { performanceDescription } = useSelector(selectModelList)
  const creditRiskDescription = UseI18n('score.standard.CORPORATE_RISK_SCORE')

  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    dispatch(getModelLists())
  }, [locale])

  return (
    <>
      <div style={{ padding: '12px 0', paddingBottom: 0 }}>
        <div
          className="dFlex alignItemsCenter justifyContentBetween"
          style={{ paddingBottom: 20 }}
        >
          <Title />
          <ContactUs />
        </div>
        <div>
          <PredictiveModel />
        </div>
        <div className="dFlex" style={{ gap: 20, paddingTop: 12 }}>
          <CreditScore
            textTitle="score.standard.CREDIT_SCORE"
            text={creditRiskDescription}
          />
          <CreditScore
            textTitle="score.standard.CORPORATE_SCORE"
            text={performanceDescription}
          />
        </div>
        <div style={{ paddingTop: 32 }}>
          <Upgrade />
        </div>
      </div>
    </>
  )
}
